import React from 'react';
import { Container } from '@ruter-ds/rds-components';
import Icon from '@ruter-ds/rds-components/dist/cjs/Icon';
import { CrossCircleIcon } from '@ruter-ds/rds-icons';
import './style.scss';

const ErrorPage = () => {
    return (
        <Container className="rds-my--l errorPage">
            <Icon className="icon" component={<CrossCircleIcon />} />

            <div className="message">
                <h2>Siden finnes ikke</h2>
                <p>Det kan være at siden er utdatert, eller at du har brukt feil holdeplassnummer. Prøv å scanne QR-kode på nytt!</p>
                <p>
                    <em>
                        The page is no longer available. It might be outdated, or it might be that an incorrect stop place id was used.
                        Please try to scan the QR code again.
                    </em>
                </p>
            </div>
        </Container>
    );
};

export default ErrorPage;
